import { useEffect, useRef } from 'react';

/**
 * Samoosvežavanje ekrana koje NE preklapa pozive.
 *
 * ZAŠTO POSTOJI
 *   `setInterval` okida bez obzira na to da li je prethodno učitavanje
 *   završilo. Dok server odgovara za sekundu to se ne primeti; čim počne da
 *   kasni, pozivi se gomilaju jedan na drugi i svi padnu na bazu kad se ona
 *   vrati — pa je najgore baš u trenutku kad joj je najteže.
 *
 *   Izmereno 06.10.2026: posle restarta baze je upit za e-fakture imao
 *   <b>403 izvršenja za petnaest minuta</b> — oko dvadeset sedam u minuti,
 *   naspram četiri i po pre podne. Devet poslovođinih ekrana sa razmakom od
 *   dva minuta ne može da napravi toliko; napravilo ih je nagomilano čekanje.
 *
 * ŠTA RADI
 *   Dok jedno učitavanje traje, sledeći otkucaj se PRESKAČE. Ne odlaže se i ne
 *   pamti — kad spor poziv konačno završi, podatak je svež i nema šta da se
 *   nadoknađuje. Dva otkucaja u redu bi značila dva ista odgovora.
 *
 * ŠTO NE RADI
 *   Ne prekida poziv koji traje. Prekid bi tražio da svaki čitalac ume da
 *   razlikuje „prekinuto" od „palo", a to je tiša greška od jednog sporog
 *   osvežavanja.
 */
export function useOsvezavanje(posao: () => Promise<unknown>, razmakMs: number): void {
  // Posao se menja na svaku promenu svojih zavisnosti; da stoji u listi
  // zavisnosti efekta, tajmer bi se postavljao iznova i odbrojavanje ne bi
  // nikad isteklo.
  const najnoviji = useRef(posao);
  najnoviji.current = posao;

  const uToku = useRef(false);

  useEffect(() => {
    let ziv = true;

    const pokreni = async () => {
      if (uToku.current) {
        return;
      }

      uToku.current = true;

      try {
        await najnoviji.current();
      } finally {
        // Oslobađa se i kad je palo: zaglavljena zastavica bi zaustavila
        // osvežavanje do ponovnog otvaranja ekrana, a to niko ne bi povezao
        // sa jednom neuspelom mrežom.
        if (ziv) {
          uToku.current = false;
        }
      }
    };

    void pokreni();

    const tajmer = window.setInterval(() => void pokreni(), razmakMs);

    return () => {
      ziv = false;
      window.clearInterval(tajmer);
    };
  }, [razmakMs]);
}
